import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import ContentCreate from 'material-ui/svg-icons/content/create';
import translate from 'admin-on-rest/lib/i18n/translate';
import FlatButton from "material-ui/FlatButton";

const styles = {
    button: {overflow: 'inherit'},
};

const EditTextButtonWithType = ({
                                    basePath = '',
                                    label = 'aor.action.edit',
                                    record = {},
                                    translate,
                                }) => (
    <FlatButton
        primary
        label={label && translate(label)}
        icon={<ContentCreate/>}
        containerElement={
            <Link to={`${basePath}/${encodeURIComponent((record) ? record.type : '')}/${(record) ? record.id : ''}`}/>
        }
        style={styles.button}
    />
);

EditTextButtonWithType.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
    translate: PropTypes.func,
};

EditTextButtonWithType.defaultProps = {
    style: {padding: 0},
};

export default translate(EditTextButtonWithType);



// WEBPACK FOOTER //
// ./src/Fuse/buttons/EditTextButtonWithType.js